import React from 'react';
import SanitizedHTML from 'components/formatting/SanitizedHTML';
import { Box } from '@mui/material';

import withOptionsWidget, { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget';
import RichTextEditorSettingsDialog from './RichTextEditorSettings';

function RichTextEditor(props: WithOptionsWidgetProps): React.JSX.Element {
  const widgetId = props.widget?.id;
  const onUpdateWidgetData = props.onUpdateWidgetData;
  const widgetRefresh = props.widgetRefresh;
  const settingsDialogIsOpen = props.settingsDialogIsOpen;
  const setSettingsDialogIsOpen = props.setSettingsDialogIsOpen;
  const editorState = props.widget?.data?.editorState;
  const htmlContent = props.widget?.data?.htmlContent;
  const backgroundColor = props.widget?.data?.backgroundColor;

  return (
    <Box sx={{position: "absolute", width: "100%", height: "100%"}}>
      <Box sx={{
        p: 2,
        pt: 1, pb:1,
        overflowY: "auto",
        height: "100%",
        backgroundColor: backgroundColor}}>
        {htmlContent && <SanitizedHTML html={htmlContent} />}
      </Box>
      {props.settingsDialogIsOpen &&
        <RichTextEditorSettingsDialog
          widgetId={widgetId}
          onUpdateWidgetData={onUpdateWidgetData}
          widgetRefresh={widgetRefresh}
          settingsDialogIsOpen={settingsDialogIsOpen}
          setSettingsDialogIsOpen={setSettingsDialogIsOpen}
          editorState={editorState}
          htmlContent={htmlContent}
          backgroundColor={backgroundColor}
        />
      }
    </Box>
  )
}

export default withOptionsWidget(RichTextEditor, {hasSettingsDialog: true})